const GrilleDesProgrammesNewIntegrated = ({language , token}) => {
    const newGrilleDesProgrammesNewIframe = "https:" +
    window.process.env.URL_GrilleDesProgrammesNew
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_GrilleDesProgrammesNew_display"
        src={newGrilleDesProgrammesNewIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default GrilleDesProgrammesNewIntegrated